import { JournalEntry } from '../../models/journal-details';

export function extractKeyValue(journalEntry: JournalEntry, key: string): any {
  const matched = journalEntry.values?.find((kv) => kv.key === key);
  return matched ? matched.value : null;
}
